export default {"src":"/_next/static/media/portuguese.34a04223.svg","height":26,"width":36};